// -----------Importar Componentes de Terceros------------------
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// -----------Importar Componentes Personalizados------------------
import BootstrapInput from '../../components/Button_Bootstrap'
import Buttonh from '../Button';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import React from "react";
// ----------- Importar Bootstrap React -------------
import { InputGroup, Form } from "react-bootstrap";
// ----------- Importar Icono de Material UI --------
import SearchIcon from "@mui/icons-material/Search";
import './css/styles.css'

const Buscar = (({ Placeholder, Value, OnChange, Icono, TextTitulo, OnClickBuscar, ShowTitle, WidthBuscador,ButtonDistribucion,InputDistribucion }) => {

  return (
    <Box width='100%'>
      {
        ShowTitle
          ?
          <Typography id='TextTitulo' variant='h3'>
            Ingrese el nombre completo de su ser querido para encontrar su conmemoración.
          </Typography>
          :
          <></>
      }

      <Box Grid container sx={{ display: 'flex', justifyContent: 'center', width: { xs: '100%', sm: WidthBuscador } }}>
        <Grid container >
          <Grid xs={12} sm={InputDistribucion}>
            


            {
              Icono
              ?
                <div style={{ position: 'relative', width: '100%' }}>
      <SearchIcon
        style={{
          position: 'absolute',
          right: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#D14081',
        }}
      />
      <input
        type="text"
        className="form-control ps-5"
        placeholder="Buscar finado..."
      />
    </div>
              :
              <FormControl sx={{ width: '100%' }} variant="standard">
              <BootstrapInput   onChange={OnChange} type='text' name='Nombre finado' placeholder={Placeholder} value={Value} id="bootstrap-input1"   />
            </FormControl>
            }
      
          </Grid>
          <Grid pl={{ xs: '0px', sm: '15px' }} sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', marginTop: { xs: '15px', sm: '0px' } }} xs={12} sm={ButtonDistribucion}>
            <Box sx={{ width: { xs: '100%', sm: '200px' } }}>
              <Buttonh Text='Buscar' Size='100%' OnClick={OnClickBuscar} Color='#D14081' BorderColor='1px solid #D14081' ColorHover='white' Textcolor='#ffff' TextcolorHover='#D14081' Disabled={false} />
            </Box>
          </Grid>
        </Grid>

      </Box>
    </Box>

  );
})

export default Buscar;

Buscar.defaultProps = {
  ShowTitle: true,
  WidthBuscador: '85%',
  InputDistribucion: 7,
  ButtonDistribucion: 5,
  Icono:false
};